// extracted by mini-css-extract-plugin
export default {"Level_title":"Level_Level_title__pTV0J","Level_element":"Level_Level_element__7NNOY","Level_Counters":"Level_Level_Counters__LHw+I","Count_element":"Level_Count_element__BHCrU"};